import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

import { LookupSearchComponent } from './components/lookup-search/lookup-search.component';
import { Icd10SearchDirective } from './directives/icd10-search/icd10-search.directive';
import { ProviderSearchDirective } from './directives/provider-search/provider-search.directive';
import { FunctionDisplayModule } from '../function-display';

@NgModule({
  declarations: [Icd10SearchDirective, LookupSearchComponent, ProviderSearchDirective],
  exports: [Icd10SearchDirective, LookupSearchComponent, ProviderSearchDirective],
  imports: [
    CommonModule,
    FormsModule,
    FunctionDisplayModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class LookupSearchModule {}
